<template>
  <div class="semi-circle-charts">
    <div v-for="(items, key) in chartData" :key="key" class="chart-container">
      <div class="chart-label">{{ items[0].Label }}</div>
      <doughnut-chart
        :chart-data="getChartData(items[0])"
        :options="getChartOptions()"
        :height="150"
      />
      <div class="chart-percentage" :class="getPercentageClass(items[0])">
        {{ calculatePercentage(items[0]) }}%
      </div>
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'

export default {
  name: 'SagSemiCircleChart',
  components: {
    DoughnutChart: {
      extends: Doughnut,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData: {
          handler() {
            this.renderChart(this.chartData, this.options)
          },
          deep: true
        }
      }
    }
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  methods: {
    getChartData(data) {
      const achieve = parseFloat(data.Achieve || data.Value || 0)
      const plan = parseFloat(data.Plan || data.Date || 0)
      const remaining = Math.max(0, plan - achieve)

      return {
        datasets: [{
          data: [achieve, remaining],
          backgroundColor: [
            this.getColor(achieve / plan),
            '#f0f0f0'
          ],
          borderWidth: 0
        }],
        labels: ['Achieve', 'Remaining']
      }
    },
    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        rotation: -Math.PI,
        circumference: Math.PI,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex]
              const value = dataset.data[tooltipItem.index]
              const label = data.labels[tooltipItem.index]
              return `${label}: ${value}`
            }
          }
        }
      }
    },
    calculatePercentage(data) {
      const achieve = parseFloat(data.Achieve || data.Value || 0)
      const plan = parseFloat(data.Plan || data.Date || 0)
      return plan > 0 ? Math.round((achieve / plan) * 100) : 0
    },
    getColor(ratio) {
      const percentage = ratio * 100
      if (percentage < 60) return '#ff4444'  // Red
      if (percentage < 90) return '#ffbb33'  // Yellow
      return '#00C851'  // Green
    },
    getPercentageClass(data) {
      const percentage = this.calculatePercentage(data)
      if (percentage < 60) return 'text-danger'
      if (percentage < 90) return 'text-warning'
      return 'text-success'
    }
  }
}
</script>

<style scoped>
.semi-circle-charts {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
}

.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;
}

.chart-label {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.chart-percentage {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 10px;
}

.text-danger {
  color: #ff4444;
}

.text-warning {
  color: #ffbb33;
}

.text-success {
  color: #00C851;
}
</style>
